module.exports = __webpack_public_path__ + "static/mopz-double1-min-9bf949b683d66e20f85f35173d01a77d.jpg";